export function isAppleMobileDevice(): boolean {
    return /(iPhone|iPod|iPad)/i.test(window.navigator.platform) ||
        (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
}

export function isAppleDesktopDevice(): boolean {
    return /(Mac|MacIntel)/i.test(window.navigator.platform);
}

export function isWindowsDevice(): boolean {
    return /(Win)/i.test(window.navigator.platform);
}

export function isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
}

export function isAppleDevice(): boolean {
    return isAppleMobileDevice() || isAppleDesktopDevice();
}
